import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../../commons/hooks/currency'
import {PricingOptionsTotalProps} from './interfaces'

export const PricingOptionTotal = ({total}: PricingOptionsTotalProps) => {
  const {getFormattedMoney} = useCurrencyFormatter()

  return <p role="cell">{getFormattedMoney(total)}</p>
}
